export default __webpack_public_path__ + "static/MediaContentThree-862e961287974f76453b0fa49173ff37.webp";